import {
    Button,
    DatePicker,
    Divider,
    Form,
    Input,
    notification,
    Upload,
    TreeSelect,
    BackTop,
} from 'antd';
import { useTranslation } from 'react-i18next';
import ImgCrop from 'antd-img-crop';
import { useEffect, useState } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import BtnSave from './BtnSave';
import GlobalService from '../../../../services/Global.service';
import moment from 'moment';

export default function Step1({ ...props }) {
    const { setStep1, editData, dsType } = props;
    const { t, i18n } = useTranslation(['hr-policy', 'translation']);
    let lang = i18n.language;
    const [fileList, setFileList] = useState([]);
    const values = props.form.getFieldsValue();
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'vendorPrivacyPolicyNameTh',
                'vendorPrivacyPolicyNameEn',
                'vendorCompanyNameTh',
                'vendorCompanyNameEn',
                'vendorEffectiveDate',
                'vendorPrivacyPolicyDataSubjectType',
            ];
            for (const [key, value] of Object.entries(
                editData?.vendorPrivacyPolicy
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
                if (
                    key === 'vendorPrivacyPolicyDataSubjectType' &&
                    value?.length <= 0
                ) {
                    check = false;
                    return;
                }
            }
            setStep1(check);
        }
    }, [editData, setStep1]);

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile', { ns: 'translation' }),
            });
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller', { ns: 'translation' }),
            });
        }

        return isJpgOrPng && isLt2M;
    };

    const onPreview = async (file) => {
        let src = file.url;

        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);

                reader.onload = () => resolve(reader.result);
            });
        }

        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        beforeUpload,
        accept: '.png,.jpg,.jpeg',
        className: 'policy',
        fileList,
        onPreview,
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);
            }
        },
        onSuccess(res, file) {
            props?.form?.setFieldValue('vendorCompanyLogoId', res?.imageId);
            setFileList([file]);
        },
        onError(err) {
            console.log('onError', err);
        },
        onRemove() {
            props?.form?.setFieldValue('vendorCompanyLogoId', null);
        },
        customRequest: async ({ file, onSuccess, onError, onProgress }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');
            // if (id) {
            //     fileList.append('action', 'image-create-application');
            //     // fileList.append('applicationId', editObject.applicationId);
            //     // fileList.append('applicationLogoId', editObject.applicationLogoId);
            // } else {
            //     fileList.append('action', 'image-create-application');
            // }
            try {
                const onUploadProgress = ({ total, loaded }) => {
                    onProgress(
                        {
                            percent: Math.round((loaded / total) * 100).toFixed(
                                2
                            ),
                        },
                        file
                    );
                };
                const { data } = await GlobalService.uploadImage(
                    fileList,
                    onUploadProgress
                );
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };
    const uploadButton = (
        <div>
            <svg
                width={17}
                height={17}
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.16536 5.16732H7.83203V7.83398H5.16536V9.16732H7.83203V11.834H9.16536V9.16732H11.832V7.83398H9.16536V5.16732ZM8.4987 1.83398C4.8187 1.83398 1.83203 4.82065 1.83203 8.50065C1.83203 12.1807 4.8187 15.1673 8.4987 15.1673C12.1787 15.1673 15.1654 12.1807 15.1654 8.50065C15.1654 4.82065 12.1787 1.83398 8.4987 1.83398ZM8.4987 13.834C5.5587 13.834 3.16536 11.4407 3.16536 8.50065C3.16536 5.56065 5.5587 3.16732 8.4987 3.16732C11.4387 3.16732 13.832 5.56065 13.832 8.50065C13.832 11.4407 11.4387 13.834 8.4987 13.834Z"
                    fill="#1890FF"
                />
            </svg>
            <div className="-mt-2 text-blue-500 opacity-90">
                {t('policy.ChooseFile', { ns: 'translation' })}
            </div>
        </div>
    );

    useEffect(() => {
        const getImage = async () => {
            if (values?.vendorCompanyLogoId) {
                try {
                    const { data } = await GlobalService.getImage(
                        values?.vendorCompanyLogoId
                    );
                    if (data.resultData?.imageId) {
                        setFileList([
                            {
                                uid: '-1',
                                name: 'image.png',
                                status: 'done',
                                url: `data:image/png;base64,${data.resultData?.imageId}`,
                            },
                        ]);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };
        getImage();
    }, [values?.vendorCompanyLogoId]);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep1(true);
            })
            .catch(() => setStep1(false));
        props.nextStep();
    };

    return (
        <>
            <div className="px-4 block_">
                <div className="text-purple-PHX font-semibold text-2xl">
                    {t('Define the policy name and organization information')}
                </div>
                <div className="text-gray-500 text-tiny">
                    {t('policy.desEtc', { ns: 'translation' })}
                </div>
                <Divider />
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    name="vendorPrivacyPolicy"
                    layout="vertical"
                    form={props?.form}
                    onValuesChange={(e, allFields) => {
                        let check = true;
                        const allowKey = [
                            'vendorPrivacyPolicyNameTh',
                            'vendorPrivacyPolicyNameEn',
                            'vendorCompanyNameTh',
                            'vendorCompanyNameEn',
                            'vendorEffectiveDate',
                            'vendorPrivacyPolicyDataSubjectType',
                        ];
                        for (const [key, value] of Object.entries(allFields)) {
                            if (allowKey.includes(key) && !value) {
                                check = false;
                            }
                            if (
                                key === 'vendorPrivacyPolicyDataSubjectType' &&
                                value?.length <= 0
                            ) {
                                check = false;
                            }
                        }
                        setStep1(check);
                    }}
                    initialValues={initial}
                >
                    <Form.Item
                        label={
                            <span className="text-[21px] font-bold">
                                {t('Name of vendor Privacy Policy')}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                        name="vendorPrivacyPolicyNameTh"
                    >
                        <Input
                            addonBefore="TH"
                            size="large"
                            placeholder={t('PlaceholderNameTH')}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                        name="vendorPrivacyPolicyNameEn"
                    >
                        <Input
                            addonBefore="EN"
                            size="large"
                            placeholder={t('PlaceholderNameEN')}
                        />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name="vendorEffectiveDate"
                        label={
                            <span className="text-[21px] font-bold">
                                {t('policy.effectiveDate', {
                                    ns: 'translation',
                                })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                    >
                        <DatePicker
                            allowClear={false}
                            size="large"
                            style={{ width: '100%' }}
                            placeholder="DD/MM/YYYY"
                            format="DD/MM/YYYY"
                        />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name={'vendorCompanyNameTh'}
                        label={
                            <span className="text-[21px] font-bold">
                                {t('policy.companyNameEn', {
                                    ns: 'translation',
                                })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                    >
                        <Input
                            placeholder={t('PlaceholderOrganizationNameTH')}
                            addonBefore="TH"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name={'vendorCompanyNameEn'}
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                    >
                        <Input
                            placeholder={t('PlaceholderOrganizationNameEN')}
                            addonBefore="EN"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name={'vendorCompanyLogoId'}
                        label={
                            <span className="text-[21px] font-bold">
                                {t('UploadLogo')}
                            </span>
                        }
                    >
                        <ImgCrop
                            beforeCrop={beforeUpload}
                            showGrid
                            rotationSlider
                            aspectSlider
                            showReset
                        >
                            <Upload {...uploadProps}>
                                {fileList?.length < 1 && uploadButton}
                            </Upload>
                        </ImgCrop>
                    </Form.Item>
                    <div className="-mt-6 text-gray-400 text-10">
                        {lang === 'en'
                            ? '*Max size of 2 MB. (Allowed file types: jpg., .png.)'
                            : '*ขนาดสูงสุด 2 MB. (ประเภทไฟล์ที่อนุญาต: jpg., .png.)'}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-[21px] font-bold">
                                {t(
                                    'Which type of data subject does this policy apply to'
                                )}
                            </span>
                        }
                        className="mt-4"
                        name={'vendorPrivacyPolicyDataSubjectType'}
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                    >
                        <TreeSelect
                            treeCheckable
                            size="large"
                            placeholder={t('Select data subject type', {
                                ns: 'translation',
                            })}
                            // disabled={
                            //     !detail?.isProcessing
                            // }
                            filterTreeNode={(search, item) => {
                                return (
                                    String(item?.title)
                                        ?.toLowerCase()
                                        ?.indexOf(search?.toLowerCase()) >= 0
                                );
                            }}
                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                            dropdownStyle={{
                                maxHeight: '300px',
                            }}
                            onChange={(ids) => setSelectedValues(ids)}
                            showArrow
                            treeData={[
                                {
                                    title:
                                        selectedValues.length ===
                                        dsType?.length ? (
                                            <span
                                                onClick={() => {
                                                    setSelectedValues([]);
                                                    props.form.setFieldValue(
                                                        'vendorPrivacyPolicyDataSubjectType',
                                                        []
                                                    );
                                                }}
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('dataFlow.UnselectAll', {
                                                    ns: 'translation',
                                                })}
                                            </span>
                                        ) : (
                                            <span
                                                onClick={() => {
                                                    setSelectedValues(
                                                        dsType.map(
                                                            (e) => e.value
                                                        )
                                                    );
                                                    props.form.setFieldsValue({
                                                        vendorPrivacyPolicyDataSubjectType:
                                                            dsType.map(
                                                                (e) => e.value
                                                            ),
                                                    });
                                                }}
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('RoPA.SelectAll', {
                                                    ns: 'translation',
                                                })}
                                            </span>
                                        ),
                                    value: 'xxx',
                                    disableCheckbox: true,
                                    disabled: true,
                                    checkable: false,
                                },
                                ...dsType,
                            ]}
                        />
                    </Form.Item>
                    <Sticky
                        mode="bottom"
                        boundaryElement=".block_"
                        stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                    >
                        {props.editMode ? (
                            <BtnSave
                                goToStep={props.goToStep}
                                loading={props.loading}
                            />
                        ) : (
                            <div className="flex items-center">
                                <Button
                                    type="primary"
                                    size="large"
                                    onClick={onNextStep}
                                >
                                    {t('policy.NextStep', {
                                        ns: 'translation',
                                    })}{' '}
                                    <ArrowRightOutlined />
                                </Button>
                                <div
                                    style={{ borderLeft: '1px solid #DBDBDB' }}
                                    className="ml-6"
                                >
                                    <Button
                                        onClick={props.saveDraft}
                                        className="text-[#1890FF]"
                                        type="link"
                                    >
                                        {t('Save Draft')}
                                    </Button>
                                    <span>
                                        {t('to save the latest changes')}
                                    </span>
                                </div>
                            </div>
                        )}
                    </Sticky>
                </Form>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    vendorPrivacyPolicyId: null,
    isPublish: false,
    vendorPrivacyPolicyNameTh:
        'นโยบายความเป็นส่วนตัวในกระบวนการจัดซื้อจัดจ้าง (Vendor Privacy Policy)',
    vendorPrivacyPolicyNameEn: 'Vendor Privacy Policy',
    vendorCompanyNameTh: '',
    vendorCompanyNameEn: '',
    vendorCompanyLogoId: '',
    vendorEffectiveDate: moment(new Date()),
    vendorPrivacyPolicyDataSubjectType: [],
    companyLogoId: '',
};
